import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/**
 * ToImage Pipe
 * find Base64 Images in text and return a image tag
 * */
@Pipe({
  name: 'toImage',
})
export class ToImagePipe implements PipeTransform {

  constructor(private sanitize: DomSanitizer) {
  }

  transform(value: any, rawValue: any, imagePlaceHolder?: boolean): any {
    if (!value || (typeof value !== 'string')) {
      return value;
    }
    return this.textToLinks(rawValue, value, imagePlaceHolder);
  }

  private textToLinks(value: string, originalValue: any, imagePlaceHolder?: boolean): SafeHtml {
    if (typeof value === 'string' && value.indexOf('data:image/') !== -1) {
      let formattedText = value;
      formattedText = formattedText.replace(formattedText,
        (m, $1) => imagePlaceHolder?'...':`<img style="width: 60%;" src="${m}"/>`);
      if (formattedText !== value) {
        return this.sanitize.bypassSecurityTrustHtml(formattedText);
      }
      return originalValue;
    }
    // as the pipe is the last step in editing values, if nothing changes its better to return original value
    return originalValue;
  }
}
